import React, { useEffect, useState } from 'react';

import './ProjectHeader.scss';

import ProducerSettingsCog from './ProducerSettingsCog/ProducerSettingsCog';
import ProjectHeaderInfo from './ProjectHeaderInfo/ProjectHeaderInfo';
import history from '../../tools/history';

import BackArrowLarge from '../../images/back-arrow-large.png';
import { getDateDifferenceFromNow } from '../../helpers/dateFormatHelper/dateFormatHelper';
import moment from 'moment';
import useProject from '../../hooks/useProject';

type ProjectHeaderProps = {
  reloadProject: () => void;
  isProducer: boolean;
};

const ProjectHeader = (props: ProjectHeaderProps) => {
  const { project } = useProject();

  const [isReadOnly, setIsReadOnly] = useState<boolean>(!!project?.broadcastStartedUtc);

  const navigateToHome = () => {
    history.push('/');
  };

  useEffect(() => {
    const isProjectStarted = () => {
      if (!!project?.broadcastStartedUtc || project?.deletedUtc) {
        setIsReadOnly(true);
      }
    };
    isProjectStarted();
  }, [project]);

  useEffect(() => {
    const checkIfStartDateHasPassed = () => {
      if (
        !isReadOnly &&
        project?.scheduledDateTime &&
        moment.duration(getDateDifferenceFromNow(project?.scheduledDateTime)).asMinutes() < 1
      ) {
        setIsReadOnly(true);
      }
    };
    const interval = setInterval(() => checkIfStartDateHasPassed(), 30000);
    checkIfStartDateHasPassed();
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);

  return (
    <header className="project-header level">
      <div className="level-left">
        {props.isProducer && (
          <button className="project-header-back-button" type="button" onClick={navigateToHome}>
            <img src={BackArrowLarge} className="project-header-back-arrow" alt="back" />
          </button>
        )}
      </div>
      <div>
        <h1 className="project-header-title">{project?.name}</h1>
      </div>
      <div className="level-right">
        <ProjectHeaderInfo />
        {props.isProducer && !isReadOnly && <ProducerSettingsCog {...props} />}
      </div>
    </header>
  );
};

export default ProjectHeader;
